import styled from "styled-components";

// Container
export const CampaignsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

// Campaign Card
export const CampaignCard = styled.div`
    background-color: #fafafa;
    border: 1.5px solid #d4d4d4;
    border-radius: 8px;
    padding: 12px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;

    &:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12), 0 2px 6px rgba(0, 0, 0, 0.15);
    }
`;

export const CampaignHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
    padding-bottom: 6px;
    border-bottom: 2px solid #aef001;
`;

export const CampaignTitle = styled.h4`
    font-size: 15px;
    font-weight: 600;
    color: #333;
    margin: 0;
`;

export const CampaignBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

// Form Items
export const FormInputRow = styled.div`
    display: flex;
    gap: 8px;
    align-items: flex-start;
    flex-wrap: wrap;

    @media (max-width: 768px) {
        flex-direction: column;
    }
`;

export const FormItem = styled.div`
    display: flex;
    flex-direction: column;
    gap: 3px;
    min-width: 90px;
`;

export const FormLabel = styled.label`
    font-weight: 600;
    color: #333;
    font-size: 11px;
`;

// Compact Form Items (for inline display)
export const CompactFormItem = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    min-width: 0;
    flex-shrink: 0;
`;

export const CompactLabel = styled.label`
    font-weight: 500;
    color: #666;
    font-size: 10px;
    white-space: nowrap;
    min-width: fit-content;
`;

// Package Bonus Section
export const PackageBonusSection = styled.div`
    margin-top: 4px;
`;

export const PackageBonusTitle = styled.span`
    font-weight: 600;
    font-size: 12px;
    color: #333;
    display: block;
    margin-bottom: 6px;
`;

export const PackageBonusList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
`;

export const PackageBonusItem = styled.div`
    background-color: #fff;
    border: 1px solid #e8e8e8;
    border-radius: 6px;
    padding: 6px 8px;
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
`;

// Time & Days Section
export const TimeSection = styled.div`
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px solid #e8e8e8;
`;

export const TimeSectionTitle = styled.span`
    font-weight: 600;
    font-size: 12px;
    color: #333;
    display: block;
    margin-bottom: 6px;
`;

// Calculation Factors Section
export const FactorsSection = styled.div`
    margin-top: 4px;
`;

export const FactorsTitle = styled.span`
    font-weight: 600;
    font-size: 11px;
    color: #333;
    margin-right: 8px;
`;

// Campaign Items List (for grouped campaigns)
export const CampaignItemsList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const CampaignItem = styled.div`
    background-color: #fff;
    border: 1px solid #e8e8e8;
    border-radius: 6px;
    padding: 10px 12px;
    transition: all 0.2s;

    &:hover {
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
    }
`;

export const CampaignItemHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
    padding-bottom: 6px;
    border-bottom: 1px dashed #e8e8e8;
`;

export const CampaignItemName = styled.span`
    font-weight: 600;
    font-size: 13px;
    color: #333;
`;

export const CampaignItemBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
`;
